import {
  AlertCenterContainer,
  AuxWindowContainer,
  useAuxWindow,
} from "@apex/component-library";
import { Box, Stack } from "@chakra-ui/react";
import { forwardRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppFooter, AppHeader } from "ui-classic-common-library";

import pkg from "../../../package.json";
import { AppRoutes } from "../../routes";
import { PrimaryNavigation } from "../PrimaryNavigation";

interface AppLayoutProps {
  children: React.ReactNode;
  subNav?: React.ReactNode;
  appTitle: string;
  isFixedHeader: boolean;
}

export const AppLayout = forwardRef<HTMLDivElement, AppLayoutProps>(
  ({ appTitle, isFixedHeader, subNav, children }, ref) => {
    const { closeAllAuxWindows } = useAuxWindow();
    const location = useLocation();
    const passthrough = location.pathname.includes(AppRoutes.AuxWindow);
    useEffect(() => {
      closeAllAuxWindows();
      // including closeAllAuxWindows as dep is causing infinite loop
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    return (
      <Stack direction="column" width="100%" height="100%" spacing={0}>
        <Box
          style={isFixedHeader ? { position: "sticky", top: 0, zIndex: 3 } : {}}
          ref={ref}
        >
          {!passthrough && (
            <>
              <AppHeader title={appTitle} />
              <PrimaryNavigation />
              <AuxWindowContainer />
              <Box>{subNav}</Box>
            </>
          )}
          <Box>
            <AlertCenterContainer />
          </Box>
        </Box>
        <Box as="main" flex="1 1 0%" backgroundColor="gray.50">
          {children}
        </Box>
        {!passthrough && (
          <>
            <AppFooter version={pkg.version} />
          </>
        )}
      </Stack>
    );
  }
);
